import styled from "@emotion/styled";

import { LiveArticleSummaryItem } from "./item";

export const Container = styled.div`
  margin-block-start: 23px;
  padding-block-start: 16px;

  border: 1px solid #d8d8d8;
  border-width: 1px 0;

  cursor: pointer;
`;

export const StyledLiveArticleSummaryItem = styled(LiveArticleSummaryItem)`
  margin-block-end: 16px;
`;
